angular.module("events")


    .controller("SearchGroupModalCtrl", ['$sce', 'preselect', 'event_id', 'listGroupsIds', 'listPositionsIds', 'LoginService', '$scope', '$uibModalInstance', 'Restangular', 'modalService', '$filter', '$http', '$stateParams', '$q', '$uibModal', 'treeService', 'is_filter', '$rootScope', 'logService',
        function ($sce, preselect, event_id, listGroupsIds, listPositionsIds, LoginService, $scope, $uibModalInstance, Restangular, modalService, $filter, $http, $stateParams, $q, $uibModal, treeService, is_filter, $rootScope, logService) {
      
        //Comprobamos si tiene permiso escritura
        $scope.allowWrite = LoginService.permissionExist("EVENTS_GUESTS_WRITE");
        $scope.space = "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;";
        $scope.is_filter = is_filter;
        //var listGroupsIds = listGroupsIds;
        let listGroups: any = {};

        $scope.getvalueArray = function (item) {
            let result = [];
            for (var i = 0; i < item; i++) {
                result.push(i);
            }
            return result;
        }

        if (preselect) { // Para buscador
            if (!is_filter) {
                // Este es el caso de añadir grupos masivamente. Tienen que estar preselecionado pero no es un filtro.
                $http({
                    method: 'get',
                    url: (window as any).CONFIG.api_url + 'EventsGuests/GetGroupsAndSelected',
                    params: { event_id: event_id }
                }).then(function (results, status, headers, config) {
                    listGroups = treeService.groups(results.data.rows, null);
                    $scope.groups = listGroups;
                    // ListGroupsIds = _.map(listGroups, function (item) { return item.id; });
                    //Seleccionamos los grupos que ya están añadidos.             
                    angular.forEach(listGroups, function (itemGroup) {
                        itemGroup.notice = 0;

                        // Comprobamos si tiene alguna posicion seleccionada.
                        let seleccionar = false;
                        angular.forEach(itemGroup.FK_positions_groups, function (position) {
                            if (position.selected) seleccionar = true;
                        });

                        var total = 0;
                        if (itemGroup.totalInGroup != itemGroup.totalLeft) {
                            // Si no están marcados todos los miembros del grupo, no marco su casilla.     
                            total = itemGroup.totalInGroup - itemGroup.totalLeft;
                            itemGroup.notice = total;
                        } else if (itemGroup.totalInGroup > 0) {
                            // Si están invitados todos los miembros del grupo, marco la casilla.
                            itemGroup.checked = true;
                            itemGroup.forceChecked = false;
                        }
                        if (seleccionar) {
                            itemGroup.checked = true;
                            itemGroup.forceChecked = true;
                        }
                    });
                });
            } else {
                $http({
                    method: 'get',
                    url: (window as any).CONFIG.api_url + 'EventsGuests/GetGroupsAndSelectedFilter',
                    params: { event_id: event_id }
                }).then(function (results, status, headers, config) {
                    listGroups = treeService.groups(results.data.rows, null);
                    $scope.groups = listGroups;

                    if (typeof (listGroupsIds) !== 'undefined' && listGroupsIds !== null && listGroupsIds.length !== 0) {
                        // Si esto existe, hay que preseleccionarlos. 
                        angular.forEach(listGroups, function (itemGroup) {
                            if (listGroupsIds.indexOf(itemGroup.id) > -1) {
                                itemGroup.checked = true;
                                itemGroup.forceChecked = true;
                                if (typeof (listPositionsIds) !== 'undefined' && listPositionsIds !== null && listPositionsIds.length !== 0) {
                                    angular.forEach(itemGroup.FK_positions_groups, function (position) {
                                        if (listPositionsIds.indexOf(position.id) > -1) position.selected = true;
                                    });
                                }
                            }

                            // Comprobamos si tiene alguna posicion seleccionada.

                            let seleccionar = false;
                            angular.forEach(itemGroup.FK_positions_groups, function (position) {
                                if (position.selected) seleccionar = true;
                            });

                            var total = 0;
                            if (itemGroup.totalInGroup != itemGroup.totalLeft) {

                                // Si no están marcados todos los miembros del grupo, no marco su casilla.              
                                total = itemGroup.totalInGroup - itemGroup.totalLeft;
                                itemGroup.notice = total;
                            } else if (itemGroup.totalInGroup > 0) {

                                // Si están invitados todos los miembros del grupo, marco la casilla.
                                itemGroup.checked = true;
                                itemGroup.forceChecked = false;
                            }
                            if (seleccionar) {
                                itemGroup.checked = true;
                                itemGroup.forceChecked = true;
                            }
                        });
                    }
                });
            }
        } else { //Para filtros
            if (is_filter) {
                $http({
                    method: 'get',
                    url: (window as any).CONFIG.api_url + 'EventsGuests/GetGroupsAndSelectedFilter',
                    params: { event_id: event_id }
                }).then(function (results, status, headers, config) {
                    listGroups = treeService.groups(results.data.rows, null);
                    $scope.groups = listGroups;

                });

            } else {
                var options = { forceGetPosition: true };
                Restangular.all('Groups').getList(options).then(function (results) {
                    var data = treeService.groups(results, null);
                    $scope.groups = data;

                    // Seleccionamos los grupos que ya están añadidos.
                    // Habria que borrarlo pero así no aparece el texto....
                    angular.forEach(data, function (item) {
                        var index = (listGroupsIds != null && typeof (listGroupsIds) !== 'undefined' ? listGroupsIds.indexOf(item.id) : -1);

                        if (index > -1) {
                            item.checked = true;
                            item.forceChecked = true;
                            // Seleccionamos los cargos
                            if (typeof (listPositionsIds) !== 'undefined' && listPositionsIds !== null && listPositionsIds.length !== 0) {
                                angular.forEach(item.FK_positions_groups, function (position) {
                                    if (listPositionsIds.indexOf(position.id) > -1) position.selected = true;
                                });
                            }
                        }
                        item.notice = 0;

                        // Obtiene el numero total de ellos... podría hacerlo sumando los del array?
                        angular.forEach(listGroups, function (itemGroup) {
                            var total = 0;
                            if (itemGroup.id == item.id) {
                                if (itemGroup.totalInGroup != itemGroup.totalLeft) {
                                    total = itemGroup.totalInGroup - itemGroup.totalLeft;
                                    item.notice = total;
                                    item.totalInGroup = itemGroup.totalInGroup;
                                }
                            }
                        });
                    });
                });
            }
        }

        $scope.forceChecked = function (id) {
            angular.forEach($scope.groups, function (child) {
                if (child.id == id) {
                    child.forceChecked = true;
                    child.show = child.checked = true;
                }
            })
        }

        $scope.showPositions = function (groupId) {
            var options = { group_id: groupId };
            $http({
                method: 'get',
                url: (window as any).CONFIG.api_url + '/Groups/GetGroupsPositions',
                params: options
            }).then(function (results, status, headers, config) {
                var positionsFromRole = results.data.rows[0].FK_positions_groups;                                
            }); 
        }

        /* Selecciona y deselecciona a todos los hijos*/

        $scope.toggleCheckTree = function (item) {
            angular.forEach($scope.groups, function (child) {
                if (child.id === item.id) {
                    //Todos los que sean el mismo grupo se modifican. Así si está en ma´s de un sitio no hay problemas.
                    child.checked = item.checked;
                    child.forceChecked = item.checked;
                    if (child.checked) child.show = true;
                }
                angular.forEach(child.FK_groups_groups_groups1, function (group_group) {
                    if (group_group.parent_group_id == item.id) {
                        child.checked = item.checked;
                        if (child.checked) child.show = true;
                        child.forceChecked = item.checked;
                        $scope.toggleCheckTree(child);
                    } else {
                        item.forceChecked = item.checked;
                    }
                });

                // TODO: si es seleccionado, seleccionamos a todos los cargos que componen el grupo
                if (item.checked) {
                    if (child.id == item.id) {
                        angular.forEach(child.FK_positions_groups, function (position) {
                            position.selected = true;
                        });
                    }
                } else {
                    if (child.id == item.id) {
                        angular.forEach(child.FK_positions_groups, function (position) {
                            position.selected = false;
                        });
                    }
                }
            });
        }
        $scope.toggleShowTree = function (item, applyToSons = false, forcedState = false ) {
            logService.debug('item')
            logService.debug(item)
            if (applyToSons) {
                var show = forcedState;
            } else {
                var show = item.show = !item.show
            }

            if (item.show == false && item.checked == true) {
                item.checked = false;
            }
            angular.forEach($scope.groups, function (child) {
                if (child.id === item.id) {
                    // Todos los que sean el mismo grupo se modifican. Así si está en ma´s de un sitio no hay problemas.
                    child.show = show
                }
                angular.forEach(child.FK_groups_groups_groups1, function (group_group) {
                    if (group_group.parent_group_id == item.id) {
                        child.show = show;
                        $scope.toggleShowTree(child, true, show);
                    } 
                });
            });
        }


        $scope.toggleCheckPosition = function (item) {
            angular.forEach($scope.groups, function (group) {
                // Recorremos todos los grupos y sus cargos para seleccionar o deseleccionar todos los que son los mismos.
                if (group.id == item.group_id) {
                    angular.forEach(group.FK_positions_groups, function (position) {
                        if (position.id == item.id) position.selected = item.selected;
                    });
                }
            });
        }

        $scope.onCancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        $scope.addGroups = function () {

            // 1) que está seleccionado.
            var listIdsPositions = [];
            var checkedGroupsIdsToSend = [];

            angular.forEach($scope.groups, function (item) {

                    angular.forEach(item.FK_positions_groups, function (posi) {
                        if (posi.selected) {
                            if (checkedGroupsIdsToSend.indexOf(item.id) < 0) checkedGroupsIdsToSend.push(item.id);
                            if (listIdsPositions.indexOf(posi.id) < 0) listIdsPositions.push(posi.id);
                        }
                    });

                /*
                    if (item.checked) {
                        if (checkedGroupsIdsToSend.indexOf(item.id) < 0) checkedGroupsIdsToSend.push(item.id);
                        angular.forEach(item.FK_positions_groups, function (posi) {
                            if (posi.selected)
                                if (listIdsPositions.indexOf(posi.id) < 0) listIdsPositions.push(posi.id);
                        });
                    } else {
                        //esactivamos sus posiciones
                        angular.forEach(item.FK_positions_groups, function (posi) {
                            posi.selected = false;
                        });
                    }
                */

            });
                $uibModalInstance.close({ groups: $scope.groups, ids: checkedGroupsIdsToSend, listPositions: listIdsPositions });
        }


    }])



  ;